$(window).scroll(function() {
  var header = $('.header');
  if($(this).scrollTop()>0){
    $(header).addClass('js-sticky');
  } else {
    $(header).removeClass('js-sticky');
  }
});

// 
var menuToggle = $('.m-toggle');
var menu = $('.menu');
var menuHamb = $('.m-hamb');

$(menuToggle).click(function(){
  $(this).toggleClass('js-open');
  $(menuHamb).toggleClass('js-open');
});


$(".btn-search").click(function() {
  let $searchContainer = $(".search-container");
  if ($searchContainer.css("display") === "none") {
    $searchContainer.css("display", "flex").hide().fadeIn(500);
  } else {
    $searchContainer.fadeOut(500, function() {
      $(this).css("display", "none");
    });
  }
});

$(".btn-close").click(function() {
  $(".search-container").fadeOut(500, function() {
    $(this).css("display", "none");
  });
});
